<template>
  <transition name="modal-fade">
    <div class="modal-container" v-if="showModal">
      <div class="modal">
        <span class="close" @click="closeModal">&times;</span>
        <img src="https://static.wixstatic.com/media/38ca38_a6d351471db1466ab2d417c652fb208e~mv2.png" alt="user-image" width="250" height="75">
        <h1 class="user-email">Bienvenid@</h1>
        <p class="user-email">{{ userEmail }}</p>
        <p class="additional-info">¡Gracias por usar Cielum PRM!</p>
        <button class="logout-btn" @click="cerrarSesion">Cerrar sesión</button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

defineProps({
  showModal: Boolean,
  userEmail: String,
});

const emit = defineEmits(['close']);

const closeModal = () => {
  emit('close');
};

const cerrarSesion = () => {
  localStorage.clear();
  router.push('/');
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  z-index: 1000;
  
}

.modal {
  background: linear-gradient(130deg, #ffffff, #bfaeff)!important;
  width: 370px;
  height: 45%;
  padding: 20px;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px 0 0 10px;
  position: relative;
  margin-top: 90px;
}

@media (min-height: 730px) and (max-height: 830px) {
  .modal {
    height: 50%;
  }
}

@media (min-height: 600px) and (max-height: 720px) {
  .modal {
    height: 60%;
  }
}

.close {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 25px;
  font-weight: bold;
  color: #555;
  cursor: pointer;
  transition: color 0.2s;
}

.close:hover {
  color: #f44336;
}

img {
  margin-bottom: 30px;
}

.user-email {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.additional-info {
  font-size: 16px;
  color: #555;
  margin-bottom: 40px;
  text-align: center;
  margin-top: 20px;
}

.logout-btn {
  margin-top: auto;
  background-color: #8f73ff;
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
  transition: background-color 0.3s ease;
}

.logout-btn:hover {
  background-color: #d9363e;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
